module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qdige9-ca19344b0d8210f0d072264c2f7c5982.jpg";